import { render, staticRenderFns } from "./workInfo.vue?vue&type=template&id=12d8ffff&scoped=true"
import script from "./workInfo.vue?vue&type=script&lang=js"
export * from "./workInfo.vue?vue&type=script&lang=js"
import style0 from "./workInfo.vue?vue&type=style&index=0&id=12d8ffff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8ffff",
  null
  
)

export default component.exports